import type { ReactElement } from 'react';

interface FieldAlertProps {
  /** 보일 사유. null 이면 아무것도 그리지 않는다. */
  readonly message: string | null;
}

/** 자동 적용 칸 바로 아래의 거부 사유 한 줄. */
export const FieldAlert = ({ message }: FieldAlertProps): ReactElement | null =>
  message === null ? null : (
    <p role="alert" className="text-sm text-destructive">
      {message}
    </p>
  );
